import portrait from "../images/profile2.png";

const ArrowUpRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <path d="M7 17L17 7M17 7H8M17 7V16" />
  </svg>
);

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="wrap">
        <div className="hero-grid">
          <div className="hero-text">
            <span className="kicker reveal">Full-Stack Software Engineer</span>
            <h1 className="hero-name reveal" data-d="1">
              Abdul Basit
              <span className="ln2">
                <em>Iqbal.</em>
              </span>
            </h1>
            <p className="hero-role reveal" data-d="2">
              3+ years building for the web
              <span className="sep">—</span>
              from pixel-perfect interfaces to resilient backends.
            </p>
            <p className="hero-lede reveal" data-d="2">
              I design and engineer performant, scalable web applications across the
              full stack, with an eye for detail and a habit of shipping.
            </p>
            <div className="hero-actions reveal" data-d="3">
              <a href="#work" className="btn-primary">
                View selected work
                <ArrowUpRight />
              </a>
              <a href="#contact" className="btn-ghost">
                Get in touch
              </a>
            </div>
            <div className="availability reveal" data-d="4">
              <span className="pulse"></span>
              Available for new roles &amp; freelance — Remote · Peshawar, Pakistan
            </div>
          </div>
          <div className="portrait-col reveal" data-d="2">
            <div className="portrait">
              <div className="panel"></div>
              <span className="pyear">’26</span>
              <img src={portrait} alt="Portrait of Abdul Basit Iqbal" />
              <span className="pcap">Abdul Basit Iqbal — Engineer</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
